import {
  getGraphNodeOnHover,
  getToggleGraphNodeSelection,
} from './toggleGraphNodeSelection';
import { ViewpointBuilderCommands } from './types';

export type ViewpointBuilderEventListeners = ReturnType<
  typeof getViewpointBuilderEventListeners
>;

export const getViewpointBuilderEventListeners = (
  commands: ViewpointBuilderCommands
) => ({
  toggleGraphNodeSelectionInMetamodelView: getToggleGraphNodeSelection(
    commands.metamodelViewCommands
  ),
  toggleGraphNodeSelectionInTraversalEdit: getToggleGraphNodeSelection(
    commands.editTraversalCommands
  ),
  toggleGraphNodeSelectionInFilters: getToggleGraphNodeSelection(
    commands.filterCommands
  ),
  collapsePathsNodeSelection: getToggleGraphNodeSelection(
    commands.collapsePathsCommands
  ),
  requiredComponentsNodeSelection: getToggleGraphNodeSelection(
    commands.requiredComponentsCommands
  ),
  collapsedPathsGraphNodeOnHover: getGraphNodeOnHover(
    commands.collapsePathsCommands
  ),
  requiredComponentsGraphNodeOnHover: getGraphNodeOnHover(
    commands.requiredComponentsCommands
  ),
});
